import dayjs from 'dayjs';
import React, { JSX, useRef } from 'react';
import { Response, ServiceId } from '@/@types/application';
import { PostType } from '@/@types/post';
import useRequest from '../libs/useRequest';
import Style from './MaintenanceSchedulePosts.module.scss';
import Post from './Post';
import PostSkeleton from './PostSkeleton';

type Props = {
  serviceId: ServiceId;
};

const MaintenanceSchedulePosts: React.FC<Props> = ({ serviceId }): JSX.Element | null => {
  const now = useRef(dayjs());
  const { data, error } = useRequest<Response<PostType>, Error>(
    serviceId
      ? {
          url: 'feeds/',
          params: {
            service: serviceId,
            type: 'maint',
            ordering: 'event_start',
            limit: 200,
          },
        }
      : null,
  );

  if (!data) {
    return (
      <div>
        {
          <div className={Style.thead}>
            <div className={Style.date}>開始予定日</div>
            <div className={Style.category}>カテゴリー</div>
            <div className={Style.title}>件名</div>
          </div>
        }
        {[...Array(3).keys()]
          .map((n) => n)
          .map((i) => {
            return <PostSkeleton key={i} />;
          })}
      </div>
    );
  }

  if (error) {
    return <div>データ取得に失敗しました。ページを再読み込みしてください。</div>;
  }

  if (data) {
    const schedulePosts = data.results.filter((post) => +post.event_end > now.current.unix());

    return (
      <div>
        {schedulePosts.length ? (
          <div className={Style.thead}>
            <div className={Style.date}>開始予定日</div>
            <div className={Style.category}>カテゴリー</div>
            <div className={Style.title}>件名</div>
          </div>
        ) : null}
        {schedulePosts.length ? (
          schedulePosts.map((post) => {
            return (
              <Post key={post.url} url={post.url} date={post.event_start} eventType={post.type} title={post.title} />
            );
          })
        ) : (
          <div>現在予定されているメンテナンスはありません</div>
        )}
      </div>
    );
  }

  return null;
};

export default MaintenanceSchedulePosts;
